import { Line } from "react-chartjs-2";

import ChartCard from "./ChartCard";

import {
    MONTH_LABELS,
    CHART_COLORS,
} from "../../../constants/admin/chart/chartConstants";

import {
    buildMonthlyData,
} from "../../../utils/admin/chartUtils";

const ChartStatisticsByMonth = ({
    carsByMonth,
    usersByMonth,
}) => {
    return (
        <ChartCard title="Thống kê theo tháng">
            <Line
                data={{
                    labels: MONTH_LABELS,

                    datasets: [
                        {
                            label: "Bất động sản mới đăng",

                            data: buildMonthlyData(
                                carsByMonth
                            ),

                            borderColor:
                                CHART_COLORS.primary,

                            backgroundColor:
                                "rgba(59,130,246,0.2)",

                            tension: 0.3,
                        },

                        {
                            label: "Người dùng mới",

                            data: buildMonthlyData(
                                usersByMonth
                            ),

                            borderColor:
                                CHART_COLORS.success,

                            backgroundColor:
                                "rgba(16,185,129,0.2)",

                            tension: 0.3,
                        },
                    ],
                }}
                options={{
                    responsive: true,

                    plugins: {
                        legend: {
                            position: "top",
                        },
                    },

                    scales: {
                        y: {
                            beginAtZero: true,
                        },
                    },
                }}
            />
        </ChartCard>
    );
};

export default ChartStatisticsByMonth;